var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashBoardLayout',{attrs:{"showNavbar":true,"isSearch":false}},[_c('div',{staticClass:"w100"},[_c('Products',{attrs:{"selecetdCatg":_vm.selecetdCatgText,"headingText":_vm.headingText}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }